<div class="search-sum-card" data-testid="main-search-client-btn-buscar" data-tour="search-button" (click)="searchState.toggle()">
  @if (!searchState.clientData() && !searchState.isLoading()){
    <div class="search-sum-card__btn-search">Buscar<mat-icon iconPositionEnd>search</mat-icon></div>
  }

  @if (searchState.isLoading()) {
    <div class="search-sum-card__box skeleton">
      <div class="skeleton__circle"></div>
      <div class="skeleton__text skeleton__text--small"></div>
    </div>

    <div class="search-sum-card__box skeleton">
      <div class="skeleton__circle"></div>
      <div class="skeleton__content">
        <div class="skeleton__text skeleton__text--medium"></div>
        <div class="skeleton__text skeleton__text--large"></div>
      </div>
    </div>

    <div class="search-sum-card__box skeleton">
      <div class="skeleton__circle"></div>
      <div class="skeleton__content">
        <div class="skeleton__text skeleton__text--medium"></div>
        <div class="skeleton__text skeleton__text--small"></div>
      </div>
    </div>

    <div class="search-sum-card__circle skeleton">
      <div class="skeleton__circle skeleton__circle--small"></div>
    </div>
  }

  @if (searchState.clientData() && !searchState.isLoading()) {
    <div class="search-sum-card__box">
      <img [src]="'../../../../../assets/images/tenants/icon'+searchState.selectedTenant()?.tenantId+'.svg'" [alt]="searchState.selectedTenant()?.tenantId" class="search-sum-card__logo" />
      <span class="search-sum-card__label search-sum-card__label--small">{{ searchState.selectedTenant()?.tenantName }}</span>
    </div>

    <div class="search-sum-card__box">
      <mat-icon fontSet="material-icons-outlined" class="search-sum-card__icon">account_circle</mat-icon>
      <div class="search-sum-card__user">
        <div class="search-sum-card__label search-sum-card__label--bold">{{ searchState.clientData()?.firstName + ' ' + searchState.clientData()?.lastName }}</div>
        <div class="search-sum-card__sub-label">
          <mat-icon class="search-sum-card__icon search-sum-card__icon--small">mail</mat-icon>
          {{ searchState.clientData()?.email }}
        </div>
      </div>
    </div>

    <div class="search-sum-card__box">
      <mat-icon fontSet="material-icons-outlined" class="search-sum-card__icon">calendar_today</mat-icon>
      <div>
        <div class="search-sum-card__label search-sum-card__label--bold">Rango de fechas</div>
        <div class="search-sum-card__sub-label">{{ searchState.dateRange() }}</div>
      </div>
    </div>
    <div class="search-sum-card__circle">
      <mat-icon fontSet="material-icons-outlined" class="search-sum-card__icon">
        {{searchState.isOpen()?'close':'chevron_right'}}
      </mat-icon>
    </div>
  }
</div>
